// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fW6qn","option":"styles_option__3EUFr","selected":"styles_selected__BXQmZ"};